/**
 * @file A point for all requests
 */

 import axios from "axios";
 import get from "lodash/get";
 import { withParams } from "../utils/url";

 const api = require("./api.json"); // tslint:disable-line:typedef

 const getHeaders = ({ locale } = {}) => ({
   headers: {
     Authorization: `Bearer ${window.localStorage.getItem("token")}`,
     "Accept-Language": locale || window.localStorage.getItem("language") || "en",
   },
 });

 const getPdfHeaders = () => ({
   params: {
     cacheBustTimestamp: Date.now(), // prevents IE cache problems on re-download
   },
   responseType: "blob",
   headers: {
     Authorization: `Bearer ${window.localStorage.getItem("token")}`,
     Accept: "application/octet-stream",
   },
 });

 const getHeadersFile = () => ({
   headers: {
     Accept: "application/json",
     "Content-Type": "multipart/form-data",
     Authorization: `Bearer ${window.localStorage.getItem("token")}`,
   },
 });

 const getHeadersRandomize = () => ({
   headers: {
     "Content-Type": "application/json",
     "Access-Control-Allow-Origin": process.env.REACT_APP_UI_URL,
   },
   auth: {
     username: process.env.REACT_APP_SECRET_NAME,
     password: process.env.REACT_APP_SECRET_KEY,
   },
 });

 /**
  * Development/ production apiUrl()
  */
 export const apiUrl = () => process.env.REACT_APP_API_URL;

 export const getAppSettings = () =>
   axios.get(`${apiUrl()}${withParams(api.appSettings)}`, getHeaders());

 export const financeExchange = ({ fromCurrency, toCurrency }) =>
   axios.get(
     `${apiUrl()}${withParams(api.financeExchange, {
       fromCurrency,
       toCurrency,
     })}`,
     getHeaders()
   );

 /**
  * login request
  */
 export const loginRequest = ({ username, password }) =>
   axios.post(`${apiUrl()}${api.login}`, { username, password });

 export const loginSamlRequest = ({ token }) =>
   axios.post(`${apiUrl()}${api.loginSaml}`, { token });

 /**
  * login 2 factor request
  */
 export const loginTwoFactorRequest = ({ username, password, code }) =>
   axios.post(`${apiUrl()}${api.loginTwoFactor}`, { username, password, code });

 /**
  * Sign out request
  */
 export const logoutRequest = () =>
   axios.post(`${apiUrl()}${api.logout}`, null, getHeaders());

 /**
  * Reset password request
  */
 export const resetPasswordRequest = ({ username }) =>
   axios.post(`${apiUrl()}${api.resetPassword}`, { username });

 /**
  * Reset password confirm user
  */
 export const resetPasswordConfirmUserRequest = ({ token }) =>
   axios.get(`${apiUrl()}${withParams(api.resetPasswordConfirm, { token })}`);

 /**
  * Reset password confirm user
  */
 export const resetPasswordConfirmRequest = ({
   token,
   password,
   confirm_password,
 }) =>
   axios.post(`${apiUrl()}${withParams(api.resetPasswordConfirm, { token })}`, {
     password,
     confirm_password,
   });

 /**
  * Get setting password user
  */
 export const setPasswordConfirmUserRequest = ({ token }) =>
   axios.get(`${apiUrl()}${withParams(api.setPasswordConfirm, { token })}`);

 /**
  * Reset password confirm user
  */
 export const setPasswordConfirmRequest = ({
   token,
   password,
   confirm_password,
 }) =>
   axios.post(`${apiUrl()}${withParams(api.setPasswordConfirm, { token })}`, {
     password,
     confirm_password,
   });

 /**
  * Reset password in profile
  */
 export const resetPasswordProfileRequest = ({
   current_password,
   new_password,
   confirm_new_password,
 }) =>
   axios.put(
     `${apiUrl()}${api.resetPasswordProfile}`,
     { current_password, new_password, confirm_new_password },
     getHeaders()
   );

 /**
  * Get Permissions
  */
 export const getPermissionsRequest = () =>
   axios.get(`${apiUrl()}${api.permissions}`, getHeaders());

 /**
  * Get Permissions Structure
  */
 export const getPermissionsStructureRequest = (params) =>
   axios.get(`${apiUrl()}${withParams(api.permissionsStructure, params)}`, getHeaders());

 export const getPermissionsStructureSuperAdminRequest = () =>
   axios.get(`${apiUrl()}/admin/settings/active-permissions`, getHeaders());

 /**
  * Get QR
  */
 export const getQRCodeRequest = () =>
   axios.get(`${apiUrl()}${api.qrCode}`, getHeaders());

 /**
  * Get notificationSettings
  */
 export const getNotificationSettingsRequest = () =>
   axios.get(`${apiUrl()}${api.notificationSettings}`, getHeaders());

 /**
  * Set notificationSettings
  */
 export const setNotificationSettingsRequest = (notifications) =>
   axios.put(
     `${apiUrl()}${api.notificationSettings}`,
     notifications,
     getHeaders()
   );

 /**
  * Get Account info
  */
 export const getAccountInfoRequest = () =>
   axios.get(`${apiUrl()}${api.accountProfile}`, getHeaders());

 /**
  * Update Account info
  */
 export const updateAccountInfoRequest = (profile) =>
   axios.put(`${apiUrl()}${api.accountProfile}`, profile, getHeaders());

 /**
  * Get two Factor status
  */
 export const getTwoFactorRequest = () =>
   axios.get(`${apiUrl()}${api.twoFactor}`, getHeaders());

 /**
  * Update two Factor status
  */
 export const updateTwoFactorMethodsRequest = (params) =>
   axios.put(`${apiUrl()}${api.twoFactor}`, params, getHeaders());

 /**
  * set two Factor status
  */
 export const setTwoFactorRequest = (status) =>
   axios.put(
     `${apiUrl()}${withParams(api.twoFactorStatus, { status })}`,
     {},
     getHeaders()
   );

 /**
  * Get Sites
  */
 export const getSitesRequest = ({consent_active} = {}) =>
   axios.get(`${apiUrl()}${withParams(api.sites, { consent_active })}`, getHeaders());

 export const getDelLogSitesRequest = ({consent_active} = {}) =>
   axios.get(`${apiUrl()}${withParams(api.delLogSites, { consent_active })}`, getHeaders());

 export const getEtmfDocumentSchemaRequest = () =>
   axios.get(`${apiUrl()}${api.etmfDocumentSchema}`, getHeaders());

 export const getSimulationSchemaRequest = () =>
   axios.get(`${apiUrl()}${api.simulationSchemaForm}`, getHeaders());

 /**
  * Get Management Sites
  */
 export const getDrugManagementSitesRequest = () =>
   axios.get(`${apiUrl()}${api.drugManagementSites}`, getHeaders());

 /**
  * Get Randomization Sites
  */
 export const getRandomizationSites = () =>
   axios.get(`${apiUrl()}${api.randomizationOwnedSites}`, getHeaders());

 /**
  * Randomize request
  */
 export const randomizeRequest = (randomize) =>
   axios.post(`${apiUrl()}/web`, randomize, getHeaders());

 /**
  * Get to sites for drug transfer request
  */
 export const getDrugManagementToSitesRequest = (from_site_id) =>
   axios.post(
     `${apiUrl()}${api.drugManagementToSites}`,
     { from_site_id },
     getHeaders()
   );

 /**
  * Get site list for randomization request
  */
 export const getRandomizationSitesRequest = (from_site_id) =>
   axios.post(
     `${apiUrl()}${api.randomizationSiteList}`,
     { from_site_id },
     getHeaders()
   );

 /**
  * Get followUp7
  */
 export const getFollowUpRequest = (subjectID) =>
   axios.get(
     `${apiUrl()}${withParams(api.followUp, { subjectID })}`,
     getHeaders()
   );

 /**
  * Get followUps7
  */
 export const getFollowUpsRequest = ({ filter_by, type, page, per_page }) =>
   axios.get(
     `${apiUrl()}${withParams(api.followups, {
       filter_by,
       type,
       page,
       per_page,
     })}`,
     getHeaders()
   );

 /**
  * Create followUp7
  */
 export const createFollowUpRequest = (subjectID, followUp) =>
   axios.post(
     `${apiUrl()}${withParams(api.followUp, { subjectID })}`,
     followUp,
     getHeaders()
   );

 /**
  * Update followUp7
  */
 export const updateFollowUpRequest = (subjectID, followUp) =>
   axios.put(
     `${apiUrl()}${withParams(api.followUp, { subjectID })}`,
     followUp,
     getHeaders()
   );

 /**
  * Lock followUp7
  */
 export const lockFollowUpRequest = (subjectID) =>
   axios.put(
     `${apiUrl()}${withParams(api.followUpLock, { subjectID })}`,
     {},
     getHeaders()
   );

 /**
  * Unlock followUp7
  */
 export const unlockFollowUpRequest = (subjectID) =>
   axios.put(
     `${apiUrl()}${withParams(api.followUpUnlock, { subjectID })}`,
     {},
     getHeaders()
   );

 /**
  * Get followUp30
  */
 export const getFollowUp30Request = (subjectID) =>
   axios.get(
     `${apiUrl()}${withParams(api.followUp30, { subjectID })}`,
     getHeaders()
   );

 /**
  * Create followUp30
  */
 export const createFollowUp30Request = (subjectID, followUp) =>
   axios.post(
     `${apiUrl()}${withParams(api.followUp30, { subjectID })}`,
     followUp,
     getHeaders()
   );

 /**
  * Update followUp30
  */
 export const updateFollowUp30Request = (subjectID, followUp) =>
   axios.put(
     `${apiUrl()}${withParams(api.followUp30, { subjectID })}`,
     followUp,
     getHeaders()
   );

 /**
  * Lock followUp30
  */
 export const lockFollowUp30Request = (subjectID) =>
   axios.put(
     `${apiUrl()}${withParams(api.followUpLock30, { subjectID })}`,
     {},
     getHeaders()
   );

 /**
  * Unlock followUp30
  */
 export const unlockFollowUp30Request = (subjectID) =>
   axios.put(
     `${apiUrl()}${withParams(api.followUpUnlock30, { subjectID })}`,
     {},
     getHeaders()
   );

 /**
  * Get subject
  */
 export const getSubjectRequest = (subjectID, skipLock, show_voided) =>
   axios.get(
     `${apiUrl()}${
       subjectID
         ? withParams(api.subjectID, { subjectID, skipLock, show_voided })
         : api.subjects
     }`,
     getHeaders()
   );

 /**
  * Delete subject
  */
 export const deleteSubjectRequest = (subjectID) =>
   axios.delete(
     `${apiUrl()}${withParams(api.subjectID, { subjectID })}`,
     getHeaders()
   );
 export const deleteSubjectReasonRequest = (subjectID, data) =>
   axios.post(
     `${apiUrl()}${withParams('/admin/subject/void/:subjectID', { subjectID })}`,
     data,
     getHeaders()
   );

 /**
  * Activate subject
  */
 export const activateSubjectRequest = (subjectID) =>
   axios.put(
     `${apiUrl()}${withParams(api.subjectActivate, { subjectID })}`,
     {},
     getHeaders()
   );

 /**
  * Lock subject
  */
 export const lockSubjectRequest = (subjectID) =>
   axios.put(
     `${apiUrl()}${withParams(api.subjectLock, { subjectID })}`,
     {},
     getHeaders()
   );

 /**
  * Unlock subject
  */
 export const unlockSubjectRequest = (subjectID) =>
   axios.put(
     `${apiUrl()}${withParams(api.subjectUnlock, { subjectID })}`,
     {},
     getHeaders()
   );

 /**
  * Update subject
  */
 export const updateSubjectRequest = (subjectID, profile) =>
   axios.put(
     `${apiUrl()}${withParams(api.subjectProfile, { subjectID })}`,
     profile,
     getHeaders()
   );

 /**
  * Create subject
  */
 export const createSubjectRequest = (profile) =>
   axios.post(`${apiUrl()}${api.subjectProfileCreate}`, profile, getHeaders());

 /**
  * Create registry IDs
  */
 export const createRegistryIDProfileRequest = (id, registry) =>
   axios.post(
     `${apiUrl()}${withParams(api.createRegistryID, { id })}`,
     registry,
     getHeaders()
   );

 /**
  * Update registry IDs
  */
 export const updateRegistryIDProfileRequest = (id, registry) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateRegistryID, { id })}`,
     registry,
     getHeaders()
   );

 /**
  * Reallocate drug
  */
 export const patientProfileReallocate = (subjectID, form) =>
   axios.put(
     `${apiUrl()}${withParams(api.subjectProfileReallocate, { subjectID })}`,
     form,
     getHeaders()
   );

 export const patientProfileSpecimenSample = (subjectID, form) =>
   axios.put(
     `${apiUrl()}${withParams(api.subjectSpecimenSample, { subjectID })}`,
     form,
     getHeaders()
   );

 /**
  * IBMReprocessing
  */
 export const IBMReprocessing = (subjectID) =>
   axios.post(
     `${apiUrl()}${withParams(api.IBMReprocessing, { subjectID })}`,
     {},
     getHeaders()
   );

 /**
  * ECOAReprocessing
  */
 export const ECOAReprocessing = (subjectID) =>
   axios.post(
     `${apiUrl()}${withParams(api.ECOAReprocessing, { subjectID })}`,
     {},
     getHeaders()
   );

 export const ImednetReprocessing = (subjectID) =>
   axios.post(
     `${apiUrl()}${withParams(api.ImednetReprocessing, { subjectID })}`,
     {},
     getHeaders()
   );

 export const ImednetCheckStatus = (subjectID) =>
   axios.get(
     `${apiUrl()}${withParams(api.ImednetCheckStatus, { subjectID })}`,
     getHeaders()
   );

 export const DatafaxReprocessing = (subjectID) =>
   axios.post(
     `${apiUrl()}${withParams(api.datafaxReprocessing, { subjectID })}`,
     {},
     getHeaders()
   );

 export const DatafaxOverwriteParticipantID = (subjectID, participantId) =>
   axios.post(
     `${apiUrl()}${withParams(api.datafaxOverwriteParticipantID, { subjectID })}`,
     {'new_participant_id': participantId},
     getHeaders()
   );

 export const DatafaxPull = (subjectID) =>
   axios.post(
     `${apiUrl()}${withParams(api.datafaxPull, { subjectID })}`,
     {},
     getHeaders()
   );

 export const DatafaxCheckStatus = (subjectID) =>
   axios.get(
     `${apiUrl()}${withParams(api.datafaxCheckStatus, { subjectID })}`,
     getHeaders()
   );


 /**
  * Get unblindings
  */
 export const getUnblindings = ({ page, per_page }) =>
   axios.post(
     `${apiUrl()}${withParams(api.unblindigs, { page, per_page })}`,
     { page, per_page },
     getHeaders()
   );

 /**
  * Get unblinding
  */
 export const getUnblindingRequest = (id, values) =>
   axios.get(
     `${apiUrl()}${withParams(api.updateUnblinding, { id })}`,
     getHeaders()
   );

 /**
  * Update unblinding
  */
 export const updateUnblindingRequest = (id, values) =>
   axios.post(
     `${apiUrl()}${withParams(api.updateUnblinding, { id })}`,
     values,
     getHeaders()
   );

 /**
  * Delete unblinding
  */
 export const deleteUnblindingRequest = (unblindingId) =>
   axios.delete(
     `${apiUrl()}${withParams(api.deleteUnblinding, { unblindingId })}`,
     getHeaders()
   );

 /**
  * Activate Unblinding
  */
 export const activateUnblindingRequest = (unblindingId) =>
   axios.put(
     `${apiUrl()}${withParams(api.activateUnblinding, { unblindingId })}`,
     {},
     getHeaders()
   );

 /**
  * Approve Unblinding
  */
 export const approveUnblindingRequest = (unblindingId) =>
   axios.put(
     `${apiUrl()}${withParams(api.approveUnblinding, { unblindingId })}`,
     {},
     getHeaders()
   );

 /**
  * Unapprove Unblinding
  */
 export const unapproveUnblindingRequest = (unblindingId) =>
   axios.put(
     `${apiUrl()}${withParams(api.unapproveUnblinding, { unblindingId })}`,
     {},
     getHeaders()
   );

 /**
  * Get Dashboard data
  */
 export const getDashboardRequest = ({
   filter,
   siteCode,
   start_date,
   end_date,
   currency,
 }) =>
   axios.get(
     `${apiUrl()}${withParams(api.dashboard, {
       filter_by: filter,
       site_code: siteCode,
       start_date,
       end_date,
       currency,
     })}`,
     getHeaders()
   );

 /**
  * Get Saes list by filter
  */
 export const getSAEsListRequest = (subjectID, siteCode) =>
   axios.get(
     `${apiUrl()}${withParams(api.saesList, {
       site_code: siteCode || undefined,
       subject_id: subjectID || undefined,
     })}`,
     getHeaders()
   );

 /**
  * Get Sae by subjectID
  */
 export const getSAERequest = (subjectID) =>
   axios.get(
     `${apiUrl()}${withParams(api.saeRecording, { subjectID })}`,
     getHeaders()
   );

 /**
  * Create SAE
  */
 export const createSAERequest = (subjectID, sae) =>
   axios.post(
     `${apiUrl()}${withParams(api.saeRecording, { subjectID })}`,
     sae,
     getHeaders()
   );

 /**
  * Update SAE
  */
 export const updateSAERequest = (subjectID, saeID, sae) =>
   axios.put(
     `${apiUrl()}${withParams(api.saeRecordingSave, { subjectID, saeID })}`,
     sae,
     getHeaders()
   );

 /**
  * Delete SAE
  */
 export const deleteSAERequest = (subjectID, saeID) =>
   axios.delete(
     `${apiUrl()}${withParams(api.saeRecordingSave, { subjectID, saeID })}`,
     getHeaders()
   );

 /**
  * Lock SAE
  */
 export const lockSAERequest = (subjectID, saeID) =>
   axios.put(
     `${apiUrl()}${withParams(api.saeLock, { subjectID, saeID })}`,
     {},
     getHeaders()
   );

 /**
  * Unlock SAE
  */
 export const unlockSAERequest = (subjectID, saeID) =>
   axios.put(
     `${apiUrl()}${withParams(api.saeUnlock, { subjectID, saeID })}`,
     {},
     getHeaders()
   );

 /**
  * Delete SAE
  */
 export const toggleActivateSAERequest = (subjectID, saeID, state) =>
   state === "inactive"
     ? axios.put(
         `${apiUrl()}${withParams(api.saeRecordingActivation, {
           subjectID,
           saeID,
           status: "activate",
         })}`,
         {},
         getHeaders()
       )
     : axios.delete(
         `${apiUrl()}${withParams(api.saeRecordingActivation, {
           subjectID,
           saeID,
           status: "deactivate",
         })}`,
         getHeaders()
       );

 /**
  * Get patients
  */
 export const getPatientsRequest = ({ page, per_page }) =>
   axios.get(
     `${apiUrl()}${withParams(api.subjects, { page, per_page })}`,
     getHeaders()
   );

 /**
  * Get documents request
  */
 export const getDocumentsSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
   filter_approve,
   include_inactive,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.documentsSearch, {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value, filter_approve, include_inactive },
     getHeaders()
   );

 /**
  * Get documents training request
  */
 export const getDocumentsTrainingSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.documentsTraining, {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value },
     getHeaders()
   );

 /**
  * Get documents public request
  */
 export const getDocumentsPublicSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.documentsPublic, {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value },
     getHeaders()
   );

 export const getDocumentsGeneralSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
 }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/general/documents", {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value },
     getHeaders()
   );

 export const getDocumentsGeneralPrivateSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
 }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/general-private/documents", {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value },
     getHeaders()
   );

 export const getDocumentsValidationSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
 }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/validation/documents", {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value },
     getHeaders()
   );

 /**
  * Get documents public request
  */
 export const getDocumentsPerSiteSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.documentsPerSite, {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value },
     getHeaders()
   );

 /**
  * Get documents site Private request
  */
 export const getDocumentsPerSitePrivateSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.documentsPerSitePrivate, {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value },
     getHeaders()
   );

 /**
  * Get documents StudyRegulatoryBinder request
  */
 export const getDocumentsStudyRegulatoryBinder = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.documentsStudyRegulatoryBinder, {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value },
     getHeaders()
   );

 /**
  * Get documents DocumentsPharmacyBinder request
  */
 export const getDocumentsPharmacyBinder = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.documentsPharmacyBinder, {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value },
     getHeaders()
   );

 /**
  * Get drug request
  */
 export const getDrugSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
   filter_approve,
   show_inactive,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.drugList, {
       name: nameSearch,
       show_inactive: show_inactive,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value, filter_approve },
     getHeaders()
   );

 /**
  * Get drug request
  */
 export const getProfileUploadsSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.profileUploadsList, {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     {},
     getHeaders()
   );

 /**
  * Get drug request
  */
 export const getInventoryRequest = ({ filter_by, filter_value }) =>
   axios.post(
     `${apiUrl()}${api.inventory}`,
     { filter_by, filter_value },
     getHeaders()
   );

 /**
  * Upload drug request
  */
 export const uploadDrugRequest = (drug) =>
   axios.post(`${apiUrl()}${api.drugUpload}`, drug, getHeaders());

 /**
  * Upload drug request
  */
 export const uploadProfileRequest = (drug) =>
   axios.post(`${apiUrl()}${api.uploadProfile}`, drug, getHeaders());

 /**
  * Activate drug request
  */
 export const activateDrugRequest = (ID) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugActivate, { ID })}`,
     {},
     getHeaders()
   );

 /**
  * Deactivate drug request
  */
 export const deactivateDrugRequest = (ID, actionComment) =>
   axios.delete(
     `${apiUrl()}${withParams(api.drugUpdate, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );


 /**
  * Mark as received drug request
  */
 export const markDrugReceivedRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugReceived, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );


 /**
  * Mark as quarantined drug request
  */
 export const markDrugQuarantinedRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugQuarantined, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );


 /**
  * Mark as reviewed drug request
  */
 export const markDrugReviewedRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugReviewed, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );


 /**
  * Mark as sent back drug request
  */
 export const markDrugSentBackRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugSentBack, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );

 /**
  * Mark as destroyed / returned
  */
 export const drugReturnedDestroyedRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugReturnedDestroyed, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );

 /**
  * Mark as lost drug request
  */
 export const drugLostRequest = (ID, actionComment) =>
   axios.put(`${apiUrl()}${withParams(api.drugLost, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );

 /**
  * Sent to patient request
  */
 export const drugSentToPatientRequest = (ID, data) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugSentToPatient, { ID })}`,
     data,
     getHeaders()
   );

 /**
  * Received by patient request
  */
 export const drugReceivedByPatientRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugReceivedByPatient, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );


 /**
  * Returned by patient request
  */
 export const drugReturnedByPatientRequest = (ID, data) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugReturnedByPatient, { ID })}`,
     data,
     getHeaders()
   );

 /**
  * Returned by patient request
  */
 export const drugPatientSentBackToFridgeRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugPatientSentBackToFridge, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );

 /**
  * Drug item events history
  */

 export const drugItemEventsHistoryRequest = (ID) =>
   axios.get(
     `${apiUrl()}${withParams(api.drugItemEventsHistory, { ID })}`,
     getHeaders()
   );

 /**
  * Drugs set status bulk
  */
 export const drugsSetStatusBulkRequest = ({
   locationId,
   vialIds,
   fromDrugStatus,
   actionOnDrug,
   actionComment
 }) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugsSetStatusBulk)}`,
     {
       location_id: locationId,
       vial_ids: vialIds,
       from_drug_status: fromDrugStatus,
       action: actionOnDrug,
       action_comment: actionComment || null,
     },
     getHeaders()
   );


 /**
  * Drug ready to dispense
  */
 export const drugReadyToDispenseRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugReadyToDispense, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );

 /**
  * Drug no longer available
  */
 export const drugNoLongerAvailableRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugNoLongerAvailable, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );

 /**
  * Drug reset to start
  */
 export const drugResetOrphanedDrugRequest = (ID, actionComment) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugResetOrphanedDrug, { ID })}`,
     {action_comment: actionComment || null},
     getHeaders()
   );

 /**
  * Drug ship request
  */
 export const transferDrugRequest = (values) =>
   axios.post(`${apiUrl()}${api.drugTransfer}`, values, getHeaders());

 /**
  * Drug ship confirm request
  */
 export const transferDrugConfirmRequest = (values) =>
   axios.put(`${apiUrl()}${api.drugTransfer}`, values, getHeaders());

 /**
  * Update drug request
  */
 export const updateDrugRequest = (ID, drug) =>
   axios.put(
     `${apiUrl()}${withParams(api.drugUpdate, { ID })}`,
     drug,
     getHeaders()
   );

 /**
  * Get subject request
  */
 export const getSubjectSearchRequest = ({
   subjectID,
   subjectSearch,
   filter_by,
   site_code,
   voided,
   events,
   event_status,
   order_direction,
   page,
   per_page,
   order_column,
   drug_status,
   filter_params = {},
   withEvents = false,
 }) =>
   axios.get(
     `${apiUrl()}${withParams(subjectID ? api.subjectID : (withEvents ? api.subjectsWithEvents : api.subjects), {
       subjectID,
       search: subjectSearch,
       filter_by,
       site_code,
       voided,
       events,
       event_status,
       order_direction,
       drug_status,
       page,
       per_page,
       order_column,
       ...filter_params,
     })}`,
     getHeaders()
   );

 /**
  * Get settings sites
  */
 export const getSettingsSitesRequest = ({
   filter_by,
   user_id,
   site_type,
   order_direction,
   order_column,
   nameSearch,
 } = {}) =>
   axios.get(
     `${apiUrl()}${withParams(api.settingsSites, {
       filter_by,
       user_id,
       site_type,
       order_direction,
       order_column,
       name: nameSearch,
     })}`,
     getHeaders()
   );

 /**
  * Get dispensing sites
  */
 export const getDispensingSitesRequest = () =>
   axios.get(`${apiUrl()}${api.dispensingSites}`, getHeaders());

 /**
  * Update Site
  */
 export const updateSiteRequest = (siteID, site) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateSite, { siteID })}`,
     site,
     getHeaders()
   );

 /**
  * Delete Site
  */
 export const deleteSiteRequest = (siteID) =>
   axios.delete(
     `${apiUrl()}${withParams(api.updateSite, { siteID })}`,
     getHeaders()
   );

 /**
  * Activate Site Randomization
  */
 export const activateSiteRandomizationRequest = (siteID) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateSiteRandomization, { siteID })}`,
     {},
     getHeaders()
   );

 /**
  * Delete Site Randomization
  */
 export const deleteSiteRandomizationRequest = (siteID) =>
   axios.delete(
     `${apiUrl()}${withParams(api.updateSiteRandomization, { siteID })}`,
     getHeaders()
   );

 /**
  * Activate Site
  */
 export const activateSiteRequest = (siteID) =>
   axios.put(
     `${apiUrl()}${withParams(api.activateSite, { siteID })}`,
     {},
     getHeaders()
   );

 /**
  * Create Site
  */
 export const createSiteRequest = (site) =>
   axios.post(`${apiUrl()}${api.createSite}`, site, getHeaders());

 /**
  * Get settings users
  */
 export const getSettingsUsersRequest = ({
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   user_id,
   site_code,
   nameSearch,
 }) =>
   axios.get(
     `${apiUrl()}${withParams(api.settingsUsers, {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
       filter_by,
       user_id,
       site_code,
     })}`,
     getHeaders()
   );

 export const getSettingsUsersPortalManagementRequest = ({
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   user_id,
   site_code,
   nameSearch,
 }) =>
   axios.get(
     `${apiUrl()}${withParams('/admin/settings/patient-users', {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
       filter_by,
       user_id,
       site_code,
     })}`,
     getHeaders()
   );

 /**
  * Get single user
  */
 export const getSettingsUserSingleRequest = (userID) =>
   axios.get(
     `${apiUrl()}${withParams(api.userSingle, { userID })}`,
     getHeaders()
   );

 /**
  * Contact Us
  */
 export const contactUsRequest = (payload) =>
   axios.post(`${apiUrl()}${api.contactUs}`, payload, getHeadersRandomize());

 /**
  * Trial documents
  */
 export const getPublicDocumentsRequest = () =>
   axios.get(`${apiUrl()}${api.publicDocuments}`, getHeadersRandomize());

 /**
  * Update User
  */
 export const updateUserRequest = (userID, user) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateUser, { userID })}`,
     user,
     getHeaders()
   );

 /**
  * Delete User
  */
 export const deleteUserRequest = (userID) =>
   axios.delete(
     `${apiUrl()}${withParams(api.updateUser, { userID })}`,
     getHeaders()
   );

 /**
  * Activate User
  */
 export const activateUserRequest = (userID) =>
   axios.put(
     `${apiUrl()}${withParams(api.activateUser, { userID })}`,
     {},
     getHeaders()
   );

 /**
  * Create User
  */
 export const createUserRequest = (user) =>
   axios.post(`${apiUrl()}${api.createUser}`, user, getHeaders());

 /**
  * Get settings roles
  */
 export const getSettingsRolesRequest = () =>
   axios.get(`${apiUrl()}${api.settingsRoles}`, getHeaders());

 /**
  * Update Role
  */
 export const updateRoleRequest = (roleID, role) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateRole, { roleID })}`,
     role,
     getHeaders()
   );

 export const updateRoleSuperAdminRequest = (role) =>
   axios.put(
     `${apiUrl()}/admin/settings/active-permissions`,
     role,
     getHeaders()
   );

 /**
  * Create Role
  */
 export const createRoleRequest = (role) =>
   axios.post(`${apiUrl()}${api.createRole}`, role, getHeaders());

 /**
  * Toggle Role activation
  */
 export const toggleActivateRoleRequest = (roleID, state) =>
   state === "inactive"
     ? axios.put(
         `${apiUrl()}${withParams(api.activateRole, { roleID })}`,
         {},
         getHeaders()
       )
     : axios.delete(
         `${apiUrl()}${withParams(api.updateRole, { roleID })}`,
         getHeaders()
       );

 /**
  * Toggle User Role activation
  */
 export const toggleUserActivateRoleRequest = (userID, roleID, state) =>
   state === "inactive"
     ? axios.put(
         `${apiUrl()}${withParams(api.userRoleSiteActivate, {
           userID,
           roleID,
         })}`,
         {},
         getHeaders()
       )
     : axios.delete(
         `${apiUrl()}${withParams(api.userRoleSiteDeactivate, {
           userID,
           roleID,
         })}`,
         getHeaders()
       );

 /**
  * Create user role
  */
 export const createUserRoleRequest = (userID, data) => {
   return axios.post(
     `${apiUrl()}${withParams(api.userRoleCreate, { userID })}`,
     data,
     getHeaders()
   );
 };

 /**
  * Update user role
  */
 export const updateUserRoleRequest = (userID, siteID, data) => {
   return axios.put(
     `${apiUrl()}${withParams(api.userRoleUpdate, { userID, siteID })}`,
     data,
     getHeaders()
   );
 };

 /**
  * Create Document
  */
 export const createDocumentRequest = (document) => {
   return axios.post(`${apiUrl()}${api.documents}`, document, getHeaders());
 };

 /**
  * Update Document
  */
 export const updateDocumentRequest = (documentID, document) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateDocument, { documentID })}`,
     document,
     getHeadersFile()
   );

 /**
  * Delete Document
  */
 export const deleteDocumentRequest = (documentID) =>
   axios.delete(
     `${apiUrl()}${withParams(api.updateDocument, { documentID })}`,
     getHeaders()
   );

 /**
  * Activate Document
  */
 export const activateDocumentRequest = (documentID) =>
   axios.put(
     `${apiUrl()}${withParams(api.activateDocument, { documentID })}`,
     {},
     getHeaders()
   );

 /**
  * Approve Document
  */
 export const approveDocumentRequest = ({ documentID, approved_by_signature, password }) =>
   axios.put(
     `${apiUrl()}${withParams(api.approveDocument, { documentID })}`,
     { approved_by_signature, password },
     getHeaders()
   );

 /**
  * Unapprove Document
  */
 export const unapproveDocumentRequest = (documentID) =>
   axios.put(
     `${apiUrl()}${withParams(api.unapproveDocument, { documentID })}`,
     {},
     getHeaders()
   );

 /**
  * Create Consent
  */
 export const getConsentRequest = ({
   consentSearch,
   filter_by,
   site_code,
   order_direction,
   page,
   per_page,
   order_column,
   consent_setting_type_code,
   consent_template_file_type_code,
   workflow_code,
   language_code,
   filter_params = {},
   show_inactive_settings,
   filter_approve,
 }) =>
   axios.get(`${apiUrl()}${withParams(api.settingsConsent, { search: consentSearch,
     filter_by,
     site_code,
     order_direction,
     page,
     per_page,
     order_column,
     show_inactive_settings,
     consent_setting_type_code,
     consent_template_file_type_code,
     language_code,
     workflow_code,
     filter_approve,
     filter_params })}`, getHeaders());

 /**
  * Create Consent
  */
 export const createConsentRequest = (consent) =>
   axios.post(`${apiUrl()}${api.settingsConsent}`, consent, getHeaders());

 /**
  * Update Consent
  */
 export const updateConsentRequest = (consentID, consent) =>
   axios.put(
     `${apiUrl()}${withParams(api.settingsConsentUpdate, { consentID })}`,
     consent,
     getHeaders()
   );

 /**
  * Delete Consent
  */
 export const deleteConsentRequest = (consentID) =>
   axios.delete(
     `${apiUrl()}${withParams(api.settingsConsentUpdate, { consentID })}`,
     getHeaders()
   );

 /**
  * Activate Consent
  */
 export const activateConsentRequest = (consentID) =>
   axios.put(
     `${apiUrl()}${withParams(api.settingsConsentActivate, { consentID })}`,
     {},
     getHeaders()
   );

 /**
  * Get settings general
  */
 export const getSettingsGeneralRequest = () => {
   return axios.get(`${apiUrl()}${api.settingsGeneral}`, getHeaders());
 };

 /**
  * Create settings
  */
 export const createSettingsGeneralRequest = (data) => {
   return axios.post(`${apiUrl()}${api.settingsGeneral}`, data, getHeaders());
 };

 /**
  * Update settings
  */
 export const updateSettingsGeneralRequest = (id, data) => {
   return axios.put(
     `${apiUrl()}${withParams(api.settingsGeneralUpdate, { id })}`,
     data,
     getHeaders()
   );
 };

 /**
  * Delete setting
  */
 export const deleteSettingsGeneralRequest = (id) => {
   return axios.delete(
     `${apiUrl()}${withParams(api.settingsGeneralUpdate, { id })}`,
     getHeaders()
   );
 };

 /**
  * Activate setting
  */
 export const activateSettingsGeneralRequest = (id) => {
   return axios.put(
     `${apiUrl()}${withParams(api.settingsGeneralActivate, { id })}`,
     {},
     getHeaders()
   );
 };

 /**
  * Get audit logs
  */
 export const getAuditLogsRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
   filter_approve,
   hide_audit_log_type,
   filter_date_from,
   filter_date_to,
 }) => {
   return axios.post(
     `${apiUrl()}${withParams(api.auditLogsList, {
       search: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value, filter_approve, hide_audit_log_type, filter_date_from, filter_date_to},
     getHeaders()
   );
 };

 /**
  * Get api configuration
  */
 export const getApiConfigurationRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
   filter_approve,
   hide_audit_log_type,
 }) => {
   return axios.post(
     `${apiUrl()}${withParams(api.apiConfigurationList, {
       search: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value, filter_approve, hide_audit_log_type },
     getHeaders()
   );
 };

 /**
  * Update audit logs
  */
 export const updateAuditLogsRequest = (id, data) => {
   return axios.put(
     `${apiUrl()}${withParams(api.auditLogUpdate, { id })}`,
     data,
     getHeaders()
   );
 };

 /**
  * Activate audit logs
  */
 export const activateAuditLogsRequest = (id) => {
   return axios.put(
     `${apiUrl()}${withParams(api.auditLogActivate, { id })}`,
     {},
     getHeaders()
   );
 };

 /**
  * Delete audit logs
  */
 export const deleteAuditLogsRequest = (id) => {
   return axios.delete(
     `${apiUrl()}${withParams(api.auditLogUpdate, { id })}`,
     getHeaders()
   );
 };


 export const activateApiConfigRequest = (id) => {
   return axios.put(
     `${apiUrl()}${withParams('/admin/api_configuration/activate/:id', { id })}`,
     {},
     getHeaders()
   );
 };
 export const deleteApiConfigRequest = (id) => {
   return axios.delete(
     `${apiUrl()}${withParams('/admin/api_configuration/:id', { id })}`,
     getHeaders()
   );
 };

 /**
  * Resend email for audit logs
  */
 export const resendAuditLogsRequest = (id) => {
   return axios.put(
     `${apiUrl()}${withParams(api.auditLogResend, { id })}`,
     {},
     getHeaders()
   );
 };

 /**
  * Reviewed audit logs
  */
 export const reviewedAuditLogsRequest = (id) => {
   return axios.put(
     `${apiUrl()}${withParams(api.auditLogReviewed, { id })}`,
     {},
     getHeaders()
   );
 };

 /**
  * Unreviewed audit logs
  */
 export const unreviewedAuditLogsRequest = (id) => {
   return axios.put(
     `${apiUrl()}${withParams(api.auditLogUnreviewed, { id })}`,
     {},
     getHeaders()
   );
 };

 /**
  * Reviewed audit logs
  */
 export const reviewedAuditLogsBulkRequest = (ids) => {
   return axios.put(
     `${apiUrl()}${withParams(api.auditLogReviewedBulk, {})}`,
     { ids },
     getHeaders()
   );
 };

 /**
  * Unreviewed audit logs
  */
 export const unreviewedAuditLogsBulkRequest = (ids) => {
   return axios.put(
     `${apiUrl()}${withParams(api.auditLogUnreviewedBulk, {})}`,
     { ids },
     getHeaders()
   );
 };

 /**
  * Get simulation sites
  */
 export const getSimulationRequest = () =>
   axios.get(`${apiUrl()}${api.simulationList}`, getHeaders());

 /**
  * Create simulation
  */
 export const createSimulationRequest = (simulation) =>
   axios.post(`${apiUrl()}${api.createSimulation}`, simulation, getHeaders());

 /**
  * Update simulation
  */
 export const updateSimulationRequest = (ID, simulation) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateSimulation, { ID })}`,
     simulation,
     getHeaders()
   );

 /**
  * Delete simulation
  */
 export const deleteSimulationRequest = (ID) =>
   axios.delete(
     `${apiUrl()}${withParams(api.updateSimulation, { ID })}`,
     getHeaders()
   );

 /**
  * Activate Site
  */
 export const activateSimulationRequest = (ID) =>
   axios.put(
     `${apiUrl()}${withParams(api.activateSimulation, { ID })}`,
     {},
     getHeaders()
   );

 /**
  * Schedule upload get
  */
 export const scheduleUploadGet = () =>
   axios.get(`${apiUrl()}${api.scheduleUpload}`, getHeaders());

 /**
  * Schedule upload test
  */
 export const scheduleUploadTest = () =>
   axios.get(`${apiUrl()}${api.scheduleUploadTest}`, getHeaders());

 /**
  * Schedule upload post
  */
 export const scheduleUploadUpdate = (schedule) =>
   axios.post(`${apiUrl()}${api.scheduleUpload}`, schedule, getHeaders());

 /**
  * Schedule upload deactivate
  */
 export const scheduleUploadActivate = () =>
   axios.put(`${apiUrl()}${api.scheduleUploadActivate}`, {}, getHeaders());

 /**
  * Schedule upload deactivate
  */
 export const scheduleUploadDeactivate = () =>
   axios.delete(`${apiUrl()}${api.scheduleUpload}`, getHeaders());

 export const scheduleUpload3Get = () =>
   axios.get(`${apiUrl()}${api.scheduleUpload3}`, getHeaders());

 export const scheduleUpload3Test = () =>
   axios.get(`${apiUrl()}${api.scheduleUpload3Test}`, getHeaders());

 export const scheduleUpload3Update = (schedule) =>
   axios.post(`${apiUrl()}${api.scheduleUpload3}`, schedule, getHeaders());

 export const scheduleUpload3Activate = () =>
   axios.put(`${apiUrl()}${api.scheduleUpload3Activate}`, {}, getHeaders());

 export const scheduleUpload3Deactivate = () =>
   axios.delete(`${apiUrl()}${api.scheduleUpload3}`, getHeaders());

 export const imednetSchedule2Get = () =>
   axios.get(`${apiUrl()}${api.imednetSchedule2}`, getHeaders());

 export const imednetSchedule2Test = () =>
   axios.get(`${apiUrl()}${api.imednetSchedule2Test}`, getHeaders());

 export const imednetSchedule2Update = (schedule) =>
   axios.post(`${apiUrl()}${api.imednetSchedule2}`, schedule, getHeaders());

 export const imednetSchedule2Activate = () =>
   axios.put(`${apiUrl()}${api.imednetSchedule2Activate}`, {}, getHeaders());

 export const imednetSchedule2Deactivate = () =>
   axios.delete(`${apiUrl()}${api.imednetSchedule2}`, getHeaders());

 export const imednetSchedule3Get = () =>
   axios.get(`${apiUrl()}${api.imednetSchedule3}`, getHeaders());

 export const imednetSchedule3Test = () =>
   axios.get(`${apiUrl()}${api.imednetSchedule3Test}`, getHeaders());

 export const imednetSchedule3Update = (schedule) =>
   axios.post(`${apiUrl()}${api.imednetSchedule3}`, schedule, getHeaders());

 export const imednetSchedule3Activate = () =>
   axios.put(`${apiUrl()}${api.imednetSchedule3Activate}`, {}, getHeaders());

 export const imednetSchedule3Deactivate = () =>
   axios.delete(`${apiUrl()}${api.imednetSchedule3}`, getHeaders());

 /**
  * Schedule upload get
  */
 export const schedule1UploadGet = () =>
   axios.get(`${apiUrl()}${api.schedule1Upload}`, getHeaders());

 /**
  * Schedule upload test
  */
 export const schedule1UploadTest = () =>
   axios.get(`${apiUrl()}${api.schedule1UploadTest}`, getHeaders());

 /**
  * Schedule upload post
  */
 export const schedule1UploadUpdate = (schedule) =>
   axios.post(`${apiUrl()}${api.schedule1Upload}`, schedule, getHeaders());

 /**
  * Schedule upload deactivate
  */
 export const schedule1UploadActivate = () =>
   axios.put(`${apiUrl()}${api.schedule1UploadActivate}`, {}, getHeaders());

 /**
  * Schedule upload deactivate
  */
 export const schedule1UploadDeactivate = () =>
   axios.delete(`${apiUrl()}${api.schedule1Upload}`, getHeaders());

 export const imednetUploadGet = () =>
   axios.get(
     `${apiUrl()}/admin/subject_profile/imednet_edc_api_push_subject`,
     getHeaders()
   );

 export const imednetUploadTest = () =>
   axios.get(
     `${apiUrl()}/admin/subject_profile/imednet_edc_api_push_subject/test`,
     getHeaders()
   );

 export const imednetUploadUpdate = (schedule) =>
   axios.post(
     `${apiUrl()}/admin/subject_profile/imednet_edc_api_push_subject`,
     schedule,
     getHeaders()
   );

 export const imednetUploadActivate = () =>
   axios.put(
     `${apiUrl()}/admin/subject_profile/imednet_edc_api_push_subject/activate`,
     {},
     getHeaders()
   );

 export const imednetUploadDeactivate = () =>
   axios.delete(
     `${apiUrl()}/admin/subject_profile/imednet_edc_api_push_subject`,
     getHeaders()
   );

 export const datafaxPushGet = () =>
   axios.get(`${apiUrl()}${api.datafaxPush}`, getHeaders());

 export const datafaxPushTest = () =>
   axios.get(`${apiUrl()}${api.datafaxPushTest}`, getHeaders());

 export const datafaxPushUpdate = (schedule) =>
   axios.post(`${apiUrl()}${api.datafaxPush}`, schedule, getHeaders());

 export const datafaxPushActivate = () =>
   axios.put(`${apiUrl()}${api.datafaxPushActivate}`, {}, getHeaders());

 export const datafaxPushDeactivate = () =>
   axios.delete(`${apiUrl()}${api.datafaxPush}`, getHeaders());

 export const datafaxPullGet = () =>
   axios.get(`${apiUrl()}${api.datafaxPull}`, getHeaders());

 export const datafaxPullTest = () =>
   axios.get(`${apiUrl()}${api.datafaxPullTest}`, getHeaders());

 export const datafaxPullUpdate = (schedule) =>
   axios.post(`${apiUrl()}${api.datafaxPull}`, schedule, getHeaders());

 export const datafaxPullActivate = () =>
   axios.put(`${apiUrl()}${api.datafaxPullActivate}`, {}, getHeaders());

 export const datafaxPullDeactivate = () =>
   axios.delete(`${apiUrl()}${api.datafaxPull}`, getHeaders());

 export const datafaxVisitsGet = () =>
   axios.get(`${apiUrl()}${api.datafaxVisits}`, getHeaders());

 export const datafaxVisitsTest = () =>
   axios.get(`${apiUrl()}${api.datafaxVisitsTest}`, getHeaders());

 export const datafaxVisitsUpdate = (schedule) =>
   axios.post(`${apiUrl()}${api.datafaxVisits}`, schedule, getHeaders());

 export const datafaxVisitsActivate = () =>
   axios.put(`${apiUrl()}${api.datafaxVisitsActivate}`, {}, getHeaders());

 export const datafaxVisitsDeactivate = () =>
   axios.delete(`${apiUrl()}${api.datafaxVisits}`, getHeaders());

 /**
  * Schedule upload get
  */
 export const scheduleEcoaUploadGet = () =>
   axios.get(`${apiUrl()}${api.scheduleEcoaUpload}`, getHeaders());

 /**
  * Schedule upload test
  */
 export const scheduleEcoaUploadTest = () =>
   axios.get(`${apiUrl()}${api.scheduleEcoaUploadTest}`, getHeaders());

 /**
  * Schedule upload post
  */
 export const scheduleEcoaUploadUpdate = (schedule) =>
   axios.post(`${apiUrl()}${api.scheduleEcoaUpload}`, schedule, getHeaders());

 /**
  * Schedule upload deactivate
  */
 export const scheduleEcoaUploadActivate = () =>
   axios.put(`${apiUrl()}${api.scheduleEcoaUploadActivate}`, {}, getHeaders());

 /**
  * Schedule upload deactivate
  */
 export const scheduleEcoaUploadDeactivate = () =>
   axios.delete(`${apiUrl()}${api.scheduleEcoaUpload}`, getHeaders());

 /**
  * Reporting get
  */
 export const getFileReporting = (type, format) =>
   axios.get(`${apiUrl()}/admin/reports/${type}?format=${format}`, getHeaders());

 /**
  * Reporting by depot
  */
 export const getFileReportingByDepot = (type, format) =>
   axios.get(
     `${apiUrl()}/admin/reports/drug_by_depot?format=${format}`,
     getHeaders()
   );

 /**
  * get Roles minimal
  */
 export const getRolesLight = () =>
   axios.get(`${apiUrl()}${api.rolesLight}`, getHeaders());

 /**
  * get Users minimal
  */
 export const getUsersLight = () =>
   axios.get(`${apiUrl()}${api.usersLight}`, getHeaders());

 /**
  * get Customers minimal
  */
 export const getCustomersLight = () =>
   axios.get(`${apiUrl()}${api.financeCustomersLight}`, getHeaders());

 /**
  * get Bulk Site Roles
  */
 export const getUserSites = (id) =>
   axios.get(
     `${apiUrl()}${withParams(api.bulkUserSites, { id })}`,
     getHeaders()
   );

 /**
  * copy Bulk User Permissions
  */
 export const copyBulkUserPermissions = (data) =>
   axios.put(`${apiUrl()}${api.bulkUserCopyPermission}`, data, getHeaders());

 /**
  * get Bulk Sites
  */
 export const getBulkSites = () =>
   axios.get(`${apiUrl()}${api.bulkSites}`, getHeaders());

 /**
  * get Bulk Site Roles
  */
 export const getBulkSiteRoles = (id) =>
   axios.get(
     `${apiUrl()}${withParams(api.bulkSiteRoles, { id })}`,
     getHeaders()
   );

 /**
  * copy Bulk Site Permissions
  */
 export const copyBulkSitePermissions = (data) =>
   axios.put(`${apiUrl()}${api.bulkSiteCopyPermission}`, data, getHeaders());

 export const copyBulkSiteChangePermissions = (data) =>
   axios.put(`${apiUrl()}${api.bulkUserChangePermission}`, data, getHeaders());

 export const getFinancePricesSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
   event_id,
   filter_by,
 }) =>
   axios.get(
     `${apiUrl()}${withParams(api.financePriceList, {
       search: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
       event_id,
       filter_by,
     })}`,
     getHeaders()
   );

 export const updateFinancePriceRequest = (id, item) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateFinancePrice, { id })}`,
     item,
     getHeaders()
   );

 export const createFinancePriceRequest = (item) =>
   axios.post(`${apiUrl()}${api.createFinancePrice}`, item, getHeaders());

 export const deleteFinancePriceRequest = (id) =>
   axios.delete(
     `${apiUrl()}${withParams(api.updateFinancePrice, { id })}`,
     getHeaders()
   );

 export const activateFinancePriceRequest = (id) =>
   axios.put(
     `${apiUrl()}${withParams(api.activateFinancePrice, { id })}`,
     {},
     getHeaders()
   );

 /**
  * Get finance customers request
  */
 export const getFinanceCustomersSearchRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
 }) =>
   axios.get(
     `${apiUrl()}${withParams(api.financeCustomers, {
       search: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     getHeaders()
   );

 export const deleteFinanceCustomerRequest = (id) =>
   axios.delete(
     `${apiUrl()}${withParams(api.updateFinanceCustomer, { id })}`,
     getHeaders()
   );

 export const activateFinanceCustomerRequest = (id) =>
   axios.put(
     `${apiUrl()}${withParams(api.activateFinanceCustomer, { id })}`,
     {},
     getHeaders()
   );

 export const createFinanceCustomerRequest = (item) =>
   axios.post(`${apiUrl()}${api.createFinanceCustomer}`, item, getHeaders());

 export const updateFinanceCustomerRequest = (id, item) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateFinanceCustomer, { id })}`,
     item,
     getHeaders()
   );

 /**
  * Get finance invoice request
  */
 export const getFinanceInvoiceSearchRequest = ({
   search,
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   event_id,
   site_code,
   customer_id,
   invoice_status,
 }) =>
   axios.get(
     `${apiUrl()}${withParams(api.financeInvoiceList, {
       search,
       page,
       per_page,
       order_column,
       order_direction,
       filter_by,
       customer_id,
       event_id,
       site_code,
       invoice_status,
     })}`,
     getHeaders()
   );

 export const deleteFinanceInvoiceRequest = (id) =>
   axios.delete(
     `${apiUrl()}${withParams(api.updateFinanceInvoice, { id })}`,
     getHeaders()
   );

 export const activateFinanceInvoiceRequest = (id) =>
   axios.put(
     `${apiUrl()}${withParams(api.activateFinanceInvoice, { id })}`,
     {},
     getHeaders()
   );

 export const updateFinanceInvoiceRequest = (id, item) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateFinanceInvoice, { id })}`,
     item,
     getHeaders()
   );

 export const createFinanceInvoiceRequest = (item) =>
   axios.post(`${apiUrl()}${api.createFinanceInvoice}`, item, getHeaders());

 export const createFinanceInvoiceItemRequest = ({ invoiceId, item }) =>
   axios.post(
     `${apiUrl()}${withParams(api.createFinanceInvoiceItem, { invoiceId })}`,
     item,
     getHeaders()
   );

 export const deleteFinanceInvoiceItemRequest = ({ invoiceId, itemId }) =>
   axios.delete(
     `${apiUrl()}${withParams(api.updateFinanceInvoiceItem, {
       invoiceId,
       itemId,
     })}`,
     getHeaders()
   );

 export const activateFinanceInvoiceItemRequest = ({ invoiceId, itemId }) =>
   axios.put(
     `${apiUrl()}${withParams(api.activateFinanceInvoiceItem, {
       invoiceId,
       itemId,
     })}`,
     {},
     getHeaders()
   );

 export const updateFinanceInvoiceItemRequest = ({ invoiceId, itemId, item }) =>
   axios.put(
     `${apiUrl()}${withParams(api.updateFinanceInvoiceItem, {
       invoiceId,
       itemId,
     })}`,
     item,
     getHeaders()
   );

 export const sentFinanceInvoiceRequest = ({ invoiceId }) =>
   axios.put(
     `${apiUrl()}${withParams(api.sentFinanceInvoiceItem, { invoiceId })}`,
     {},
     getHeaders()
   );

 export const draftFinanceInvoiceRequest = ({ invoiceId }) =>
   axios.put(
     `${apiUrl()}${withParams(api.draftFinanceInvoiceItem, { invoiceId })}`,
     {},
     getHeaders()
   );

 export const paidFinanceInvoiceRequest = ({ invoiceId }) =>
   axios.put(
     `${apiUrl()}${withParams(api.paidFinanceInvoiceItem, { invoiceId })}`,
     {},
     getHeaders()
   );

 export const cancelFinanceInvoiceRequest = ({ invoiceId }) =>
   axios.put(
     `${apiUrl()}${withParams(api.cancelFinanceInvoiceItem, { invoiceId })}`,
     {},
     getHeaders()
   );

 export const downloadFinanceInvoiceRequest = ({ invoiceId }) =>
   axios.get(
     `${apiUrl()}${withParams(api.downloadFinanceInvoiceItem, { invoiceId })}`,
     getPdfHeaders()
   );

 export const getGeneratedEventsRequest = ({
   page,
   per_page,
   order_column,
   order_direction,
   filter_by,
   filter_value,
   start_date,
   end_date,
   filter_approve,
 }) =>
   axios.post(
     `${apiUrl()}${withParams(api.generatedEventsList, {
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     { filter_by, filter_value, start_date, end_date, filter_approve },
     getHeaders()
   );

 export const updateGeneratedEventsRequest = (event) =>
   axios.put(
     `${apiUrl()}${withParams(api.generatedEvent, { ID: event.id })}`,
     event,
     getHeaders()
   );

 export const deleteGeneratedEventsRequest = (event) =>
   axios.delete(
     `${apiUrl()}${withParams(api.generatedEvent, { ID: event.id })}`,
     getHeaders()
   );

 export const clearCacheGeneratedEventsRequest = () =>
   axios.post(
     `${apiUrl()}${withParams(api.generatedEventClearCache)}`,
     {},
     getHeaders()
   );

 export const setGeneratedEventsItemsRequest = (data) =>
   axios.post(`${apiUrl()}${api.generatedEventsItems}`, { data }, getHeaders());

 export const getFinanceInvoiceEventItemListRequest = ({ id, site_id }) =>
   axios.get(
     `${apiUrl()}${withParams(api.invoiceEventItemList, { id, site_id })}`,
     getHeaders()
   );

 export const getFinanceInvoiceEventItemRequest = ({ invoiceId, itemId }) =>
   axios.get(
     `${apiUrl()}${withParams(api.invoiceEventItem, { invoiceId, itemId })}`,
     getHeaders()
   );

 export const deleteFinanceInvoiceEventItemRequest = ({ invoiceId, itemId }) =>
   axios.delete(
     `${apiUrl()}${withParams(api.invoiceEventItem, { invoiceId, itemId })}`,
     getHeaders()
   );

 export const activateFinanceInvoiceEventItemRequest = ({ invoiceId, itemId }) =>
   axios.put(
     `${apiUrl()}${withParams(api.invoiceEventItemActivate, {
       invoiceId,
       itemId,
     })}`,
     {},
     getHeaders()
   );

 /**
  * Create Patient Profile Document
  */
 export const createPatientProfileDocumentRequest = (document) => {
   return axios.post(
     `${apiUrl()}${api.patientProfileDocuments}`,
     document,
     getHeaders()
   );
 };

 /**
  * Update Patient Profile Document
  */
 export const updatePatientProfileDocumentRequest = (documentID, document) =>
   axios.put(
     `${apiUrl()}${withParams(api.updatePatientProfileDocument, {
       documentID,
     })}`,
     document,
     getHeadersFile()
   );

 /**
  * Delete Patient Profile Document
  */
 export const deletePatientProfileDocumentRequest = (documentID) =>
   axios.delete(
     `${apiUrl()}${withParams(api.deletePatientProfileDocument, {
       documentID,
     })}`,
     getHeaders()
   );

 /**
  * Activate Patient Profile Document
  */
 export const activatePatientProfileDocumentRequest = (documentID) =>
   axios.put(
     `${apiUrl()}${withParams(api.activatePatientProfileDocument, {
       documentID,
     })}`,
     {},
     getHeaders()
   );

 /**
  * Get newsletter request
  */
 export const getNewsletterRequest = ({
   search,
   page,
   per_page,
   order_column,
   order_direction,
 }) =>
   axios.get(
     `${apiUrl()}${withParams(api.newsletterList, {
       search,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     getHeaders()
   );

 /**
  * Create Newsletter
  */
 export const createNewsletterRequest = (newsletter) => {
   return axios.post(`${apiUrl()}${api.newsletter}`, newsletter, getHeaders());
 };

 /**
  * Update Newsletter
  */
 export const updateNewsletterRequest = (id, newsletter) =>
   axios.put(
     `${apiUrl()}${withParams(api.newsletterByID, { id })}`,
     newsletter,
     getHeadersFile()
   );

 /**
  * Delete Newsletter
  */
 export const deleteNewsletterRequest = (id) =>
   axios.delete(
     `${apiUrl()}${withParams(api.newsletterByID, { id })}`,
     getHeadersFile()
   );

 /**
  * Activate Newsletter
  */
 export const activateNewsletterRequest = (id) =>
   axios.put(
     `${apiUrl()}${withParams(api.newsletterActivateByID, { id })}`,
     {},
     getHeadersFile()
   );

 /**
  * Send Newsletter
  */
 export const sendNewsletterRequest = (id) =>
   axios.put(
     `${apiUrl()}${withParams(api.newsletterSendByID, { id })}`,
     {},
     getHeadersFile()
   );

 /**
  * Upload Newsletter Image
  */
 export const uploadNewsletterImage = (data) =>
   axios.post(`${apiUrl()}${api.newsletterUploadImage}`, data, getHeadersFile());

 /**
  * Import all translations
  */
 export const importTranslations = (data) =>
   axios.post(`${apiUrl()}${api.importExportTranslations}`, data, getHeaders());

 /**
  * Export all translations
  */
 export const exportTranslations = () =>
   axios.get(`${apiUrl()}${api.importExportTranslations}`, getHeaders());

 /**
  * Get all translations
  */
 export const listTranslations = ({ locale, key, module, value } = {}) =>
   axios.get(
     `${apiUrl()}${withParams(api.translations, { language: locale, key, module, value })}`,
     getHeaders({ locale })
   );

 /**
  * Get all translations cache
  */
 export const getLastUpdatedTranslation = ({ languageId }) =>
   axios.get(
     `${apiUrl()}${withParams(api.languagesCache, { id: languageId })}`,
     getHeaders()
   );

 /**
  * Get all translations management page
  */
 export const listTranslationsAdmin = ({ locale, key, module, value } = {}) =>
   axios.get(
     `${apiUrl()}${withParams(api.translationsAdmin, { language: locale, key, module, value })}`,
     getHeaders({ locale })
   );


 /**
  * Update translation
  */
 export const updateTranslation = (module, key, value, languageId) =>
   axios.put(
     `${apiUrl()}${api.translationsAdmin}`,
     { module, key, value, language: languageId },
     getHeaders()
   );

 /**
  * Get all Languages
  */
 export const listLanguages = ({ status = "all" } = {}) =>
   axios.get(
     `${apiUrl()}${withParams(api.languages, { status })}`,
     getHeaders()
   );

 /**
  * Create language
  */
 export const createLanguage = ({ name, code }) =>
   axios.post(`${apiUrl()}${api.languages}`, { name, code }, getHeaders());

 /**
  * Update language
  */
 export const updateLanguage = ({ id, active, code, name }) =>
   axios.put(
     `${apiUrl()}${api.languages}`,
     { id, active, code, name },
     getHeaders()
   );

 /**
  * Update user language
  */
 export const updateUserLanguage = ({ languageId }) =>
   axios.put(`${apiUrl()}${api.userLanguage}`, { id: languageId }, getHeaders());

 export const getPrivateFileLinkRequest = ({ url }) =>
   axios.post(
     `${apiUrl()}${withParams(api.privateDocument)}`,
     { url },
     getHeaders()
   );

 export const customFormList = () =>
   axios.get(`${apiUrl()}${withParams(api.customForms)}`, getHeaders());

 export const customFormSingleGet = (slug) =>
   axios.get(
     `${apiUrl()}${withParams(api.customFormsById, { slug })}`,
     getHeaders()
   );

 export const customFormCreate = (data) =>
   axios.post(`${apiUrl()}${withParams(api.customForms)}`, data, getHeaders());

 export const customFormUpdate = (data, slug) =>
   axios.put(
     `${apiUrl()}${withParams(api.customFormsById, { slug })}`,
     data,
     getHeaders()
   );

 export const customFormApprove = (slug) =>
   axios.put(
     `${apiUrl()}${withParams(api.customFormsApproveById, { slug })}`,
     {},
     getHeaders()
   );

 export const customFormDisapprove = (slug) =>
   axios.put(
     `${apiUrl()}${withParams(api.customFormsDisapproveById, { slug })}`,
     {},
     getHeaders()
   );

 export const customFormUnlock = (slug) =>
   axios.put(
     `${apiUrl()}${withParams(api.customFormsUnlockById, { slug })}`,
     {},
     getHeaders()
   );

 export const customFormLock = (slug) =>
   axios.put(
     `${apiUrl()}${withParams(api.customFormsLockById, { slug })}`,
     {},
     getHeaders()
   );

 export const customFormDelete = (slug) =>
   axios.delete(
     `${apiUrl()}${withParams(api.customFormsById, { slug })}`,
     getHeaders()
   );

 export const customFormActivate = (slug) =>
   axios.put(
     `${apiUrl()}${withParams(api.customFormActivate, { slug })}`,
     {},
     getHeaders()
   );

 export const getEventsManagementList = () =>
   axios.get(`${apiUrl()}${withParams(api.eventsManagement)}`, getHeaders());

 export const createPatientEvent = (data) =>
   axios.post(
     `${apiUrl()}${withParams(api.eventsManagement)}`,
     data,
     getHeaders()
   );

 export const updatePatientEvent = (data) =>
   axios.put(
     `${apiUrl()}${withParams(api.eventsManagement)}`,
     data,
     getHeaders()
   );

 export const linkFormsToPatientEvent = ({ id, data }) =>
   axios.post(
     `${apiUrl()}${withParams(api.formEventsManagement, { id })}`,
     { data },
     getHeaders()
   );

 export const getForms = () =>
   axios.get(`${apiUrl()}${withParams(api.formsManagement)}`, getHeaders());

 export const getEventsForPatient = (subject_id) =>
   axios.get(
     `${apiUrl()}${withParams(api.patientEvents, { subject_id })}`,
     getHeaders()
   );

 export const getCustomFormSchema = (slug) =>
   axios.get(
     `${apiUrl()}${withParams(api.customFormsSchema, { slug })}`,
     getHeaders()
   );

 export const postCustomFormSchema = (slug, subjectID, data) =>
   axios.post(
     `${apiUrl()}${withParams(api.customFormsPatientSubject, {
       slug,
       subjectID,
     })}`,
     data,
     getHeaders()
   );

 export const validateCustomForm = (slug, data) =>
   axios.post(
     `${apiUrl()}${withParams(api.customFormsValidate, { slug })}`,
     data,
     getHeaders()
   );

 export const postCustomFormRandomization = (data) =>
   axios.post(
     `${apiUrl()}${withParams(api.customFormsRandomization, {})}`,
     data,
     getHeaders()
   );

 export const getCustomFormData = (slug, subjectID) =>
   axios.get(
     `${apiUrl()}${withParams(api.customFormsPatientSubject, {
       slug,
       subjectID,
     })}`,
     getHeaders()
   );

 export const getTheme = () =>
   axios.get(`${apiUrl()}${withParams(api.theme)}`, getHeaders());

 export const updateTheme = (data) =>
   axios.post(`${apiUrl()}${withParams(api.theme)}`, data, getHeaders());

 export const getRandomizationConfig = () =>
   axios.get(`${apiUrl()}${withParams(api.randomizationConfig)}`, getHeaders());

 export const postRandomizationConfig = (data) =>
   axios.post(
     `${apiUrl()}${withParams(api.randomizationConfig, {})}`,
     data,
     getHeaders()
   );

 export const getDocumentsConfig = () =>
   axios.get(`${apiUrl()}${withParams(api.documentsConfig)}`, getHeaders());

 export const getConsentConfig = () =>
   axios.get(`${apiUrl()}${withParams(api.consentConfig)}`, getHeaders());


 export const getDelLogConfig = () =>
   axios.get(`${apiUrl()}${withParams(api.delLogConfig)}`, getHeaders());

 export const getInboundApiConfig = () =>
   axios.get(`${apiUrl()}${withParams(api.inboundApiConfig)}`, getHeaders());

 export const postDocumentsConfig = (data) =>
   axios.post(
     `${apiUrl()}${withParams(api.documentsConfig, {})}`,
     data,
     getHeaders()
   );

 export const postConsentConfig = (data) =>
   axios.post(
     `${apiUrl()}${withParams(api.consentConfig, {})}`,
     data,
     getHeaders()
   );

 export const postDelLogConfig = (data) =>
   axios.post(
     `${apiUrl()}${withParams('/projectconf/delegation-log-config', {})}`,
     data,
     getHeaders()
   );

 export const postInboundApiConfig = (data) =>
   axios.post(
     `${apiUrl()}${withParams('/projectconf/inbound-api-configs', {})}`,
     data,
     getHeaders()
   );

 export const getSubjectsFilterGenerator = () =>
   axios.get(
     `${apiUrl()}${withParams(api.subjectsFilterGenerator)}`,
     getHeaders()
   );

 export const getDrugManagementConfig = () =>
   axios.get(`${apiUrl()}${withParams(api.drugManagementConfig)}`, getHeaders());

export const getSamlConfigsRequest = () =>
  axios.get(`${apiUrl()}${withParams('/admin/saml/configs')}`, getHeaders());

 export const patchSamlConfigRequest = (id, data) =>
   axios.patch(
     `${apiUrl()}${withParams('/admin/saml/configs/:id', { id })}`,
     data,
     getHeaders()
   );

export const samlConfigProperties = (type) =>
  axios.get(`${apiUrl()}${withParams('/saml/:type/config-properties', { type })}`, {}, getHeaders());


 export const postDrugManagementConfig = (data) =>
   axios.post(
     `${apiUrl()}${withParams(api.drugManagementConfig, {})}`,
     data,
     getHeaders()
   );

 export const getProjectConfig = () =>
   axios.get(`${apiUrl()}${withParams(api.projectConfig)}`, getHeaders());

 export const lockProjectConfig = () =>
   axios.put(
     `${apiUrl()}${withParams(api.lockProjectConfig)}`,
     {},
     getHeaders()
   );

 export const unlockProjectConfig = () =>
   axios.put(
     `${apiUrl()}${withParams(api.unlockProjectConfig)}`,
     {},
     getHeaders()
   );

 export const getFinanceEventsList = () =>
   axios.post(
     `${apiUrl()}${withParams(api.financeEventsList)}`,
     {},
     getHeaders()
   );

 export const getSubjectIssuesList = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
 }) =>
   axios.get(
     `${apiUrl()}${withParams(api.subjectIssues, {
       search: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     getHeaders()
   );

 export const createSubjectIssueRequest = (item) =>
   axios.post(`${apiUrl()}${api.subjectIssuesAdd}`, item, getHeaders());

 export const updateSubjectIssueRequest = (id, item) =>
   axios.put(
     `${apiUrl()}${withParams(api.subjectIssue, { id })}`,
     item,
     getHeaders()
   );

 export const getAccountProfileId = (password) =>
   axios.post(`${apiUrl()}${api.accountProfileId}`, { password }, getHeaders());

 export const getUnassignedEvents = () =>
   axios.get(`${apiUrl()}${api.milestoneUnassignedEvents}`, getHeaders());

 export const getMilestoneEvents = () =>
   axios.get(`${apiUrl()}${api.milestoneEvents}`, getHeaders());

 export const createMilestoneEvent = (data) =>
   axios.post(`${apiUrl()}${api.milestoneEvents}`, data, getHeaders());

 export const updateMilestoneEvents = (data) =>
   axios.put(`${apiUrl()}${api.milestoneEvents}`, data, getHeaders());

 export const getTestDossage = () =>
   axios.post(
     `${apiUrl()}/projectconf/drug-management-config/test-dosage`,
     {
       dose_calculation_active: true,
       calculate_based_on_time: true,
       interval_repeat_times: 10,
       drug_name: "fwefew",
       dosage_amount_per_kg: 1.0,
       repeat_frequency_hours: 1,
       drug_administration_type: "tablet",
       maximum_dosage_weight: 100,
       calculate_based_on_weight: true,
       active_ingredient_interval_hours: 1,
       treatment_group: "_default_",
       drug_state: "solid_tablet",
       maximum_dosage_amount: 100.0,
       minimum_dosage_weight: 50,
       minimum_dosage_amount: 50.0,
       additional_instructions: "fchtjyku",
     },
     getHeaders()
   );

 export const getDelegationLogsRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
 }) =>
   axios.get(
     `${apiUrl()}${withParams("/admin/delegation_logs", {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     getHeaders()
   );

 export const getDelegationLogsSigningRequest = ({
   nameSearch,
   page,
   per_page,
   order_column,
   order_direction,
 }) =>
   axios.get(
     `${apiUrl()}${withParams("/admin/delegation_logs/my_signature", {
       name: nameSearch,
       page,
       per_page,
       order_column,
       order_direction,
     })}`,
     getHeaders()
   );

 export const getDelegationLogRequest = ({ id }) =>
   axios.get(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id", {
       id,
     })}`,
     getHeaders()
   );

 export const getDelegationLogSigningRequest = ({ id, type }) =>
   axios.get(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/signatures/:type", {
       id,
       type,
     })}`,
     getHeaders()
   );

 export const postDelegationLogRequest = ({ site_id }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs/")}`,
     { site_id },
     getHeaders()
   );

 export const duplicateDelegationLogRequest = ({ id, site_id }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/duplicate", { id })}`,
     { site_id },
     getHeaders()
   );

 export const putDelegationLogRequest = ({ id, data }) =>
   axios.put(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id", { id })}`,
     data,
     getHeaders()
   );

 export const getDelegationLogStaffAllRequest = ({ id }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/staff/import_all", {
       id,
     })}`,
     {},
     getHeaders()
   );

 export const getDelegationLogStaffMissingRequest = ({ id }) =>
   axios.post(
     `${apiUrl()}${withParams(
       "/admin/delegation_logs/:id/staff/import_missing",
       { id }
     )}`,
     {},
     getHeaders()
   );

 export const getDelegationLogRolesAllRequest = ({ id }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/roles/import_all", {
       id,
     })}`,
     {},
     getHeaders()
   );

 export const getDelegationLogRolesMissingRequest = ({ id }) =>
   axios.post(
     `${apiUrl()}${withParams(
       "/admin/delegation_logs/:id/roles/import_missing",
       { id }
     )}`,
     {},
     getHeaders()
   );

 export const delegationLogApproveRequest = ({ id }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs_approve/:id", { id })}`,
     {},
     getHeaders()
   );

 export const delegationLogLockRequest = ({ id }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs_lock/:id", { id })}`,
     {},
     getHeaders()
   );

 export const delegationLogUnlockRequest = ({ id }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs_unlock/:id", { id })}`,
     {},
     getHeaders()
   );

 export const delegationLogDisableRequest = ({ id }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/disable", { id })}`,
     {},
     getHeaders()
   );

 export const delegationLogUpVersionRequest = ({ id }) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/up", { id })}`,
     {},
     getHeaders()
   );

 export const getDelegationLogPdf = (id) =>
   axios.get(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/file", { id })}`,
     { ...getHeaders(), responseType: "arraybuffer" }
   );

 export const etmfDocumentSchemaDownload = () =>
   axios.get(
     `${apiUrl()}${withParams("/admin/etmf-document-schema/download")}`,
     { ...getHeaders(), responseType: "arraybuffer" }
   );

 export const etmfDocumentSchemaGet = () =>
   axios.get(`${apiUrl()}${withParams("/admin/etmf-document-schema")}`, {
     ...getHeaders(),
   });

 export const etmfDocumentSchemaUpload = (data) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/etmf-document-schema/upload")}`,
     data,
     getHeadersFile()
   );

 export const getEstimateReturn = (drug_id) =>
   axios.get(
     `${apiUrl()}${withParams(
       `/admin/drug_management/drug/${drug_id}/estimate_return`
     )}`,
     {
       ...getHeaders(),
     }
   );


 export const getDocumentApproveStatus = (id) =>
   axios.get(
     `${apiUrl()}${withParams(
       `/admin/document/show-approval/:id`, {id}
     )}`,
     {
       ...getHeaders(),
     }
   );

 export const previewDelegationLogPdf = (id) =>
   axios.get(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/preview_file", { id })}`,
     { ...getHeaders(), responseType: "arraybuffer" }
   );

 export const delegationLogSignRequest = (id, type, data) =>
   axios.post(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/signatures/:type", { id, type })}`,
     data,
     getHeaders()
   );

 export const delegationLogPDFSnapshotsRequest = id =>
   axios.get(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/pdf-snapshots", { id })}`,
     getHeaders()
   );

 export const getDelegationLogPDFSnapshotRequest = (id) =>
   axios.get(
     `${apiUrl()}${withParams("/admin/delegation_logs/:id/pdf-snapshots/download", { id })}`,
     { ...getHeaders(), responseType: "arraybuffer" },
   );

 export const getPermissionsFileRequest = () =>
   axios.get(
     `${apiUrl()}${api.downloadPermissions}`,
     getHeaders()
   );

export const uploadPermissionsFileRequest = (data) =>
  axios.post(
    `${apiUrl()}${api.uploadPermissions}`,
    data,
    getHeadersFile()
  );

export const getFollowupsRequest = (site_id) =>
  axios.get(`${apiUrl()}${withParams(api.followupsList, { site_id })}`, getHeaders());


export const deleteConsentSiteSpecificRequest = (site_id) =>
  axios.delete(
    `${apiUrl()}${withParams('/admin/settings/site/:site_id/consent', { site_id })}`,
    getHeaders()
  );

export const activateConsentSiteSpecificRequest = (site_id) =>
  axios.put(
    `${apiUrl()}${withParams('/admin/settings/site/:site_id/consent', { site_id })}`,
    {},
    getHeaders()
  );

export const getEtmfDocumentSchemaFilterRequest = (on_page, filters = {}) =>
  axios.post(`${apiUrl()}${withParams(`/admin/etmf-document-schema/filter`, { on_page })}`, filters, getHeaders());

export const getDocumentVersionsRequest = (document_id) =>
  axios.get(`${apiUrl()}${withParams(`/admin/document/versions/:document_id`, { document_id })}`, getHeaders());

export const invoiceRemoveEventsRequest = ({ invoiceId }) =>
  axios.delete(`${apiUrl()}${withParams(api.invoiceRemoveEvents, { invoiceId })}`, getHeaders());

export const getFinanceInvoiceSitesRequest = () =>
  axios.get(`${apiUrl()}${api.financeInvoiceSitesList}`, getHeaders());


export const endOfStudyLogRequest = ({ id, data }) =>
  axios.post(
    `${apiUrl()}${withParams("/admin/delegation_logs/:id/end_of_study", { id })}`,
    data,
    getHeaders()
  );

export const updateDrugExpiry = data =>
  axios.put(`${apiUrl()}${withParams(api.updateDrugExpiry)}`, data, getHeaders());

export const getDrugManagementDownload = () =>
  axios.get(`${apiUrl()}/admin/drug_management/download`, getHeaders());


export const getConsentUnassignedRecordsRequest = ({
  nameSearch,
  page,
  per_page,
  order_column,
  created_by_me,
  order_direction,
  workflow,
  site_code,
}) =>
  axios.get(
    `${apiUrl()}${withParams(api.consentUnassignedRecordsRequest, {
      search: nameSearch,
      page,
      per_page,
      created_by_me,
      order_column,
      order_direction,
      workflow,
      site_code
    })}`,
    getHeaders()
  );

export const getConsentSettingsWfRequest = () =>
  axios.get(`${apiUrl()}${withParams('/admin/consent_settings')}`, getHeaders());


export const getPatientProfile = () =>
  axios.get(`${apiUrl()}${withParams('/admin/subject/patient-profile')}`, getHeaders());


export const getConsentSettingsRequest = () =>
  axios.get(`${apiUrl()}${withParams('/admin/consent_settings')}`, getHeaders());

export const getDashboardConsentRequest = () =>
  axios.get(`${apiUrl()}${withParams(api.dashboardConsent)}`, getHeaders());

export const approveConsentRequest = ({ consentID, approved_by_signature, password }) =>
  axios.put(
    `${apiUrl()}${withParams('/admin/settings/consent_form/approve/:consentID', { consentID })}`,
    { approved_by_signature, password },
    getHeaders()
  );

export const unApproveConsentRequest = (consentID) =>
  axios.put(
    `${apiUrl()}${withParams('/admin/settings/consent_form/unapprove/:consentID', { consentID })}`,
    {},
    getHeaders()
  );


export const resendConsentNotification = (consentID) =>
  axios.post(
    `${apiUrl()}${withParams('/consent/resend_email/:consentID', { consentID })}`,
    {},
    getHeaders()
  );



export const getAuditLogsActiveTypes = () =>
  axios.post(
    `${apiUrl()}${withParams('/admin/settings/audit_logs_active_types')}`,
    {},
    getHeaders()
  );

export const getDocumentDashboardInventoryRequest = (filters) =>
  axios.post(`${apiUrl()}${withParams('/admin/document/dashboard/inventory')}`, {...filters}, getHeaders());

export const getDocumentDashboardVisibilityTypeRequest = (filters) =>
  axios.post(`${apiUrl()}${withParams('/admin/document/dashboard/visibility-type')}`, {...filters}, getHeaders());

export const getDocumentDashboardBySiteRequest = (filters) =>
  axios.post(`${apiUrl()}${withParams('/admin/document/dashboard/sites')}`, {...filters}, getHeaders());

export const getDocumentDashboardPrimaryCategoryRequest = (filters) =>
  axios.post(`${apiUrl()}${withParams('/admin/document/dashboard/primary-category')}`, {...filters}, getHeaders());

export const getDocumentDashboardExpireRequest = (filters) =>
  axios.post(`${apiUrl()}${withParams('/admin/document/dashboard/expire')}`, {...filters}, getHeaders());

export const getDocumentDashboardMissingRequest = (filters) =>
  axios.post(`${apiUrl()}${withParams('/admin/document/dashboard/missing-documents')}`, {...filters}, getHeaders());

export const getDocumentDashboardMissingGeneralRequest = (filters) =>
  axios.post(`${apiUrl()}${withParams('/admin/document/dashboard/missing-documents/general')}`, {...filters}, getHeaders());

export const getDocumentDashboardMissingPerSiteRequest = (filters) =>
  axios.post(`${apiUrl()}${withParams('/admin/document/dashboard/missing-documents/per-site')}`, {...filters}, getHeaders());

export const getDocumentDashboardMissingPerSiteListRequest = () =>
  axios.get(`${apiUrl()}${withParams('/admin/document/dashboard/missing-per-site')}`, getHeaders());

export const getDocumentDashboardRequiredStatusPerSiteRequest = (filters = {}) =>
  axios.get(`${apiUrl()}${withParams('/admin/document/dashboard/required-status-per-site', filters)}`, getHeaders());

export const getDocumentDashboardRequiredStatusGeneralRequest = (filters = {}) =>
  axios.get(`${apiUrl()}${withParams('/admin/document/dashboard/required-status-general', filters)}`, getHeaders());

export const getApiTypeSchemaRequest = (api_type) =>
  axios.get(`${apiUrl()}${withParams('/admin/api_configuration/:api_type/schema', { api_type })}`, getHeaders());

export const testApiTypeRequest = (api_id) =>
  axios.post(`${apiUrl()}${withParams('/admin/api_configuration/test/:api_id', { api_id })}`, {}, getHeaders());

export const testMappingApiTypeRequest = (api_id) =>
  axios.post(`${apiUrl()}${withParams('/admin/api_configuration/test-mapping/:api_id', { api_id })}`, {}, getHeaders());

export const postApiTypeRequest = (data, api_service_type) =>
  axios.post(`${apiUrl()}${withParams('/admin/api_configuration/create/:api_service_type', { api_service_type } )}`, data, getHeaders());

export const putApiTypeRequest = (data, api_id) =>
  axios.put(`${apiUrl()}${withParams('/admin/api_configuration/:api_id', { api_id })}`, data, getHeaders());

export const uploadApiConfigurationRequest = (data, api_id) =>
  axios.post(`${apiUrl()}${withParams('/admin/external_api/upload/:api_id', { api_id })}`, data, getHeaders());

export const apiConfigurationExportDownload = (api_id) =>
  axios.get(
    `${apiUrl()}${withParams("/admin/external_api/download/:api_id", { api_id })}`,
    { ...getHeaders(), responseType: "arraybuffer" }
  );
export const apiConfigurationExampleDownload = () =>
  axios.get(
    `${apiUrl()}${withParams("/admin/external_api/example")}`,
    { ...getHeaders(), responseType: "arraybuffer" }
  );


export const apiFieldsReferenceDownload = (api_id) =>
  axios.get(
    `${apiUrl()}${withParams("/admin/external_api/fields_reference_download/:api_id", { api_id })}`,
    { ...getHeaders(), responseType: "arraybuffer" }
  );


export const DCTMSFieldsReferenceDownload = (api_id) =>
  axios.get(
    `${apiUrl()}${withParams("/admin/external_api/dctms_fields_reference_download/:api_id", { api_id })}`,
    { ...getHeaders(), responseType: "arraybuffer" }
  );

export const pullAllSubjectsRequest = (api_id) =>
  axios.post(`${apiUrl()}${withParams('/admin/external_api/run/:api_id/pull', { api_id })}`, {}, getHeaders());

export const pushAllSubjectsRequest = (api_id) =>
  axios.post(`${apiUrl()}${withParams('/admin/external_api/run/:api_id/push', { api_id })}`, {}, getHeaders());

export const generateConfigData = (data) =>
  axios.post(`${apiUrl()}${withParams('/admin/permuted-blocks-config/generate-pd-data-and-list')}`, data, getHeaders());

export const generateConfigDataCSV = (data) =>
  axios.post(
    `${apiUrl()}${withParams("/admin/permuted-blocks-config/generate-pb-csv")}`,
    data,
    { ...getHeaders(), responseType: "arraybuffer" });

export const simulateConfigDataCSV = (data) =>
  axios.post(
    `${apiUrl()}${withParams("/admin/permuted-blocks-config/generate_and_simulate")}`,
    data,
    { ...getHeaders(), responseType: "arraybuffer" });

export const RedcapPullRequest = (subjectID) =>
  axios.post(
    `${apiUrl()}${withParams("/admin/subject_profile/:subjectID/redcap/pull_subject", { subjectID })}`,
    {},
    getHeaders()
  );

export const RedcapPushRequest = (subjectID) =>
  axios.post(
    `${apiUrl()}${withParams("/admin/subject_profile/:subjectID/redcap/push_subject", { subjectID })}`,
    {},
    getHeaders()
  );

export const RedcapCheckStatus = (subjectID) =>
  axios.post(
    `${apiUrl()}${withParams("/admin/subject_profile/:subjectID/redcap/check_subject_status", { subjectID })}`,
    {},
    getHeaders()
  );

export const delegationLogTestTemplateRequest = (type, query) =>
  axios.get(
    `${apiUrl()}${withParams(`/admin/delegation_logs/example/${type}/file?${query}`)}`,
    { ...getHeaders(), responseType: "arraybuffer" });


export const getCFschema = (url) => axios.get(url, getHeaders());

export const getPermutedBlocksActiveRequest = () =>
  axios.get(`${apiUrl()}${withParams('/admin/permuted-blocks-config/show-active')}`, getHeaders());

export const getPermutedBlocksActiveCSVRequest = () =>
  axios.get(`${apiUrl()}${withParams('/admin/permuted-blocks-config/active/csv')}`, { ...getHeaders()});

export const getPermutedBlocksActiveCSVArrayBufferRequest = () =>
  axios.get(`${apiUrl()}${withParams('/admin/permuted-blocks-config/active/csv')}`, { ...getHeaders(), responseType: "arraybuffer" });

export const getPermutedBlocksActiveJSONRequest = () =>
  axios.get(`${apiUrl()}${withParams('/admin/permuted-blocks-config/active/detail')}`, getHeaders());

export const uploadPermutedBlocksCSV = (data) =>
  axios.post(
    `${apiUrl()}${withParams("/admin/permuted-blocks-config/upload-csv")}`,
    data,
    getHeadersFile()
  );


export const simulatePermutedBlocksConfigDataCSV = (data) =>
  axios.post(
    `${apiUrl()}${withParams("/projectconf/randomization-config/simulate")}`,
    data,
    { ...getHeaders(), responseType: "arraybuffer" });


export const getSpecimenSamplesSearchRequest = ({ nameSearch, page, per_page, order_column, order_direction, filter_by, filter_value, filter_approve }) =>
  axios.get(`${apiUrl()}${withParams(api.specimenSampleList, { search: nameSearch, page, per_page, order_column, order_direction, filter_by, filter_approve, [filter_by]: filter_value })}`, getHeaders());
export const activateSpecimenSampleRequest = ID =>
  axios.put(`${apiUrl()}${withParams(api.specimenSamplesActivate, { ID })}`, {}, getHeaders());
export const deactivateSpecimenSampleRequest = ID =>
  axios.delete(`${apiUrl()}${withParams(api.specimenSamplesUpdate, { ID })}`, getHeaders());
export const uploadSpecimenSampleRequest = specimenSamples =>
  axios.post(`${apiUrl()}${api.specimenSamplesUpload}`, specimenSamples, getHeaders());
export const specimenFileSubjectUpload = (specimenSamples, { subjectID, id }) =>
  axios.post(`${apiUrl()}${withParams(api.specimenFileSubjectUpload, { subjectID, id })}`, specimenSamples, getHeaders());
export const updateSiteSpecimenSampleRequest = (ID, site_code) =>
  axios.put(`${apiUrl()}${withParams(api.specimenSamplesKitUpdate, { ID })}`, { site_code }, getHeaders());

export const specimenSchemaDownload = () =>
  axios.get(
    `${apiUrl()}${withParams(api.specimenSamplesDownloadExample)}`,
    { ...getHeaders(), responseType: "arraybuffer" }
  );

export const getSpecimenSamplesSettingsList = () =>
  axios.get(`${apiUrl()}${withParams(api.specimenSamplesSettings)}`, getHeaders());
export const getSpecimenSampleEvents = (ID) =>
  axios.get(`${apiUrl()}${withParams(api.specimenSampleEvents, { ID })}`, getHeaders());
export const getSpecimenSamplesAutocompleteSearchRequest = ({ nameSearch, siteCode }) =>
  axios.get(`${apiUrl()}${withParams(api.specimenSampleListBySite, { site_code: siteCode, query: nameSearch })}`, getHeaders());
export const createSampleSetting = (data) =>
  axios.post(
    `${apiUrl()}${withParams(api.specimenSamplesSettings)}`,
    data,
    getHeaders()
  );
export const updateSampleSetting = (data, ID) =>
  axios.put(
    `${apiUrl()}${withParams(api.specimenSamplesSettingsID, { ID })}`,
    data,
    getHeaders()
  );


export const createSpecimenProfileEvent = (data, { subjectID, id }) =>
  axios.post(
    `${apiUrl()}${withParams(api.specimenSampleEventsProfile, { subjectID, id })}`,
    data,
    getHeaders()
  );
export const updateSpecimenProfileEvent = (data, { subjectID, id }) =>
  axios.post(
    `${apiUrl()}${withParams(api.specimenSampleEventsProfileUpdate, { subjectID, id })}`,
    data,
    getHeaders()
  );

export const detachSpecimenProfileEvent = ({ subjectID, id }) =>
  axios.delete(
    `${apiUrl()}${withParams(api.specimenSampleEventsProfile, { subjectID, id })}`,
    getHeaders()
  );

export const getEmailTemplatesRequest = ({
   search,
   page,
   per_page,
   order_column,
   order_direction,
   is_modified,
   is_overridden,
   is_approved
 }) =>
  axios.get(
    `${apiUrl()}${withParams(api.emailTemplatesList, {
      search,
      page,
      per_page,
      order_column,
      order_direction,
      is_modified,
      is_overridden,
      is_approved
    })}`,
    getHeaders()
  );

export const getEmailTemplateByIDRequest = (id) =>
  axios.get(
    `${apiUrl()}${withParams(`/admin/email_templates/${id}`)}`,
    { ...getHeaders()});

export const getEmailTemplatePreviewRequest = (id) =>
  axios.get(
    `${apiUrl()}${withParams(`/admin/email_templates/${id}/preview`)}`,
    { ...getHeaders()});


export const toggleEmailTemplateActivationRequest = (id) =>
  axios.patch(
    `${apiUrl()}${withParams('/admin/email_templates/:id/toggle_activation', { id })}`,
    {},
    getHeaders()
  );

export const toggleEmailTemplateApproveRequest = (id) =>
  axios.patch(
    `${apiUrl()}${withParams('/admin/email_templates/:id/toggle_approve', { id })}`,
    {},
    getHeaders()
  );

export const updateEmailTemplateRequest = (id, data) =>
  axios.put(
    `${apiUrl()}${withParams(`/admin/email_templates/:id`, { id })}`,
    data,
    getHeaders()
  );

export const resetEmailTemplateRequest = (id) =>
  axios.patch(
    `${apiUrl()}${withParams(`/admin/email_templates/:id/reset`, { id })}`,
    {},
    getHeaders()
  );

export const importConsentRequest = (consent) =>
  axios.post(`${apiUrl()}${api.importConsent}`, consent, getHeaders());

export const copyConsentRequest = (id) =>
  axios.put(`${apiUrl()}${withParams(api.copyConsent, { id })}`, {}, getHeaders());

export const exportConsentRequest = (data) =>
  axios.post(
    `${apiUrl()}${withParams(api.exportConsent)}`,
    data,
    { ...getHeaders(), responseType: "arraybuffer" }
    );

export const getConsentSingleRequest = ({id}) =>
  axios.get(`${apiUrl()}${withParams(api.settingsConsentUpdate, { consentID: id })}`, getHeaders());

export const getAllLanguagesRequest = () =>
  axios.get(`${apiUrl()}${withParams('/admin/languages')}`, getHeaders());

export const postDFNetParticipantIdRequest = (data) =>
  axios.post(`${apiUrl()}${withParams('/consent/dfnet-participant-id')}`, data, getHeaders());

export const postRandomizationInitialValuesRequest = ({ site_code, subject_code }) =>
  axios.post(`${apiUrl()}${withParams('/admin/custom_forms/randomization-web/initial-values')}`, { site_code, subject_code }, getHeaders());


export const getSamlLoginRequest = (loginType) =>
  axios.get(`${apiUrl()}${withParams('/saml/:loginType/login', { loginType })}`, getHeaders());

export const samlConfigActivate = (id) =>
  axios.patch(`${apiUrl()}${withParams('/admin/saml/configs/:id/active', { id })}`, {}, getHeaders());

export const samlConfigInactivate = (id) =>
  axios.patch(`${apiUrl()}${withParams('/admin/saml/configs/:id/inactive', { id })}`, {}, getHeaders());

export const getAuthConfig = () =>
  axios.get(`${apiUrl()}${withParams('/projectconf/auth-config')}`, getHeaders());

export const loginCheck = (data) =>
  axios.post(`${apiUrl()}${withParams('/admin/login/check')}`, data, getHeaders());

export const postAuthConfig = (data) =>
  axios.post(
    `${apiUrl()}${withParams('/projectconf/auth-config', {})}`,
    data,
    getHeaders()
  );



// WEBPACK FOOTER //
// ./src/api/requests.js